module.exports = __webpack_public_path__ + "media/images/pages/ai/pocstock-ethical-ai-face-6-10ac6ee1db89ec4ff555477e4046f788.png";